import React, { useEffect, useState } from "react";
import qs from "qs";
import { clearUserData, persistUser } from "../../utils/persist";
import { useHistory } from "react-router";
import useLoginWidget from "../../hooks/useLoginWidget";
import getEnvEndpoints from "../../utils/endpoints";
import Spinner from "../common/Spinner/Spinner";
import { useLocation } from "react-router";

const endpoints = getEnvEndpoints();

const LoginForm = ({ refresh, onSuccess, accessUpdated, setAccessUpdated }) => {
  const [readyToRedirect, setReadyToRedirect] = useState(false);
  const loaded = useLoginWidget();
  const history = useHistory();
  const [sharedRedirect, setSharedRedirect] = useState(null)

  const location = useLocation();
  const queryPath = new URLSearchParams(location.search);
  const queryRedirect = queryPath.get("redirect");

  const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });


    useEffect(() => {
        let redirectUri = queryPath.get("redirect");

        window.authTime = 0;

        window.onload = () => {
            if (document.querySelector('pmi-login-iframe'))
                document.querySelector('pmi-login-iframe').login();
        }

        window.onLogin = async (data) => {
            // fix redirect loop from hell
            // this is a hack to work around the numerous components that handle redirect

            if (document.querySelector('pmi-login-iframe'))
                document.querySelector('pmi-login-iframe').login();

            await persistUser(data);

            console.log(redirectUri);

            if (redirectUri && redirectUri?.toLowerCase().includes('sharedposts/show') || redirectUri?.toLowerCase().includes('posts/')) {
                //history.push(redirectUri);
                window.location.href = redirectUri;
            }
            //end fix redirect loop from hell
            else {
                queryPath.delete('redirect')
                setAccessUpdated(false);
                setReadyToRedirect(true);

                if (refresh) {
                    window.location.reload();
                } else {
                    if (window.authTime !== data.auth_time) {
                        // This callback is called multiple times, so avoid by the help of auth time.
                        window.authTime = data.auth_time;
                        await onSuccess();
                    }
                }
            }
        };

        window.onLogout = async (data) => {
            clearUserData();
        };
    }, [history, query.back, refresh, onSuccess]);

    useEffect(() => {
        setSharedRedirect(queryRedirect)
        if (accessUpdated && readyToRedirect) {
            const path = query.back ? `${query.back}` : "/home";
             const loginRedirectPath = sharedRedirect && path === "/home" ? `${sharedRedirect}` : path;
             history.push(loginRedirectPath);
            //history.push(queryRedirect);
        }
        else if(!accessUpdated && readyToRedirect) {
            const path = "/home";
            history.push(path);
        }
    }, [accessUpdated, readyToRedirect, queryRedirect]);

  return (
    <div className="container mx-auto w-full px-4 md:w-2/3 md:px-0 xl:w-1/3">
      {loaded && !readyToRedirect && (
        <pmi-login-iframe
          client-id={endpoints.clientID}
          on-logged-in="onLogin"
          on-logged-out="onLogout"
          modal="false"
          scope={endpoints.scope}
          return-url={endpoints.loginRedirect}
          style={{
            display: "block",
            height: "550px",
          }}
        ></pmi-login-iframe>
      )}

      {readyToRedirect && (
        <div className="mt-10 flex justify-center">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default LoginForm;
